// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.switch__Nyid4 {
  display: flex;
  align-items: center;
  column-gap: 16px;
  cursor: pointer;
}

.checkboxInput__nFvoo {
  display: none;
}

.line__C5OGO {
  width: 28px;
  height: 13px;
  border-radius: 30px;
  opacity: 1;
  display: flex;
  align-items: center;
  border: 1px solid var(--selection-controls-toggle-surface-default);
  padding: 1.5px 1px;
}

.activeLine__YUwqy {
  background-color: var(--selection-controls-toggle-surface-active);
  border: unset;
  padding: 2px;
}

.disabled__MMnmI {
  opacity: 0.6;
  cursor: auto;
}

.slider__ht32r {
  width: 9px;
  height: 9px;
  background-color: var(--selection-controls-toggle-surface-default);
  border-radius: 50%;
  transition: transform 150ms cubic-bezier(0.4, 0, 0.2, 1) 0ms, transform 150ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;
}

.activeSlider__GaENx {
  background-color: var(--selection-controls-toggle-thumb-active);
  transform: translateX(15px);
}

.fieldLabel__CyLcM {
  color: var(--selection-controls-toggle-text);
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 18px;
  text-box-trim: none;
}

.helperText__yp6EO {
  font-size: 10px;
  font-weight: 400;
  line-height: 12px;
  color: var(--inputs-error-text-helper);
  margin-top: 4px;
  min-height: 11px;
}
@media (max-width: 850px) {
  .helperText__yp6EO {
    font-size: 8px;
    line-height: 8px;
    margin-top: 2px;
    min-height: 8px;
  }
}

@media print {
  .switchWrapper__yXgMq {
    display: none;
  }
}`, "",{"version":3,"sources":["webpack://./../src/components/uikit/Switch/style.module.scss"],"names":[],"mappings":"AA0EA;EACE,aAAA;EACA,mBAAA;EACA,gBAAA;EACA,eAAA;AAzEF;;AA4EA;EACE,aAAA;AAzEF;;AA4EA;EACE,WAAA;EACA,YAAA;EACA,mBAAA;EACA,UAAA;EACA,aAAA;EACA,mBAAA;EACA,kEAAA;EACA,kBAAA;AAzEF;;AA4EA;EACE,iEAAA;EACA,aAAA;EACA,YAAA;AAzEF;;AA4EA;EACE,YAAA;EACA,YAAA;AAzEF;;AA4EA;EACE,UAAA;EACA,WAAA;EACA,kEAAA;EACA,kBAAA;EACA,8GACE;AA1EJ;;AA8EA;EACE,+DAAA;EACA,2BAAA;AA3EF;;AA8EA;EACE,4CAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,mBAAA;AA3EF;;AA8EA;EACE,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,sCAAA;EACA,eAAA;EACA,gBAAA;AA3EF;AA6EE;EARF;IASI,cAAA;IACA,gBAAA;IACA,eAAA;IACA,eAAA;EA1EF;AACF;;AA6EA;EACE;IACE,aAAA;EA1EF;AACF","sourcesContent":["%scrollbar-style {\n  scrollbar-color: rgba(0, 0, 0, 0.2) rgba(0, 0, 0, 0.05);\n  scrollbar-width: auto;\n\n  &::-webkit-scrollbar {\n    width: 6px;\n    height: 6px;\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-track {\n    background: rgba(0, 0, 0, 0.05);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background: rgba(0, 0, 0, 0.2);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb:hover {\n    background: #888;\n    border-radius: 3px;\n  }\n}\n@mixin scrollBar {\n  &::-webkit-scrollbar {\n    width: 6px;\n    height: 6px;\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-track {\n    background: rgba(0, 0, 0, 0.05);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background: rgba(0, 0, 0, 0.2);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb:hover {\n    background: #888;\n    border-radius: 3px;\n  }\n}\n\n@mixin ellipsis-text {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: pre-wrap;\n  word-wrap: break-word;\n  display: -webkit-box;\n  -webkit-box-orient: vertical;\n}\n\n@mixin tooltip {\n  padding: 8px !important;\n  opacity: 1 !important;\n  filter: drop-shadow(0 0 1px rgba(12, 26, 75, 0.24));\n  border-radius: 4px !important;\n  text-align: left !important;\n}\n\n@mixin modalTitle {\n  color: var(--header-title-main);\n  font-size: 18px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: 20px;\n  text-transform: uppercase;\n}\n\n.switch {\n  display: flex;\n  align-items: center;\n  column-gap: 16px;\n  cursor: pointer;\n}\n\n.checkboxInput {\n  display: none;\n}\n\n.line {\n  width: 28px;\n  height: 13px;\n  border-radius: 30px;\n  opacity: 1;\n  display: flex;\n  align-items: center;\n  border: 1px solid var(--selection-controls-toggle-surface-default);\n  padding: 1.5px 1px;\n}\n\n.activeLine {\n  background-color: var(--selection-controls-toggle-surface-active);\n  border: unset;\n  padding: 2px;\n}\n\n.disabled {\n  opacity: 0.6;\n  cursor: auto;\n}\n\n.slider {\n  width: 9px;\n  height: 9px;\n  background-color: var(--selection-controls-toggle-surface-default);\n  border-radius: 50%;\n  transition:\n    transform 150ms cubic-bezier(0.4, 0, 0.2, 1) 0ms,\n    transform 150ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;\n}\n\n.activeSlider {\n  background-color: var(--selection-controls-toggle-thumb-active);\n  transform: translateX(15px);\n}\n\n.fieldLabel {\n  color: var(--selection-controls-toggle-text);\n  font-size: 12px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 18px;\n  text-box-trim: none;\n}\n\n.helperText {\n  font-size: 10px;\n  font-weight: 400;\n  line-height: 12px;\n  color: var(--inputs-error-text-helper);\n  margin-top: 4px;\n  min-height: 11px;\n\n  @media (max-width: 850px) {\n    font-size: 8px;\n    line-height: 8px;\n    margin-top: 2px;\n    min-height: 8px;\n  }\n}\n\n@media print {\n  .switchWrapper {\n    display: none;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"switch": `switch__Nyid4`,
	"checkboxInput": `checkboxInput__nFvoo`,
	"line": `line__C5OGO`,
	"activeLine": `activeLine__YUwqy`,
	"disabled": `disabled__MMnmI`,
	"slider": `slider__ht32r`,
	"activeSlider": `activeSlider__GaENx`,
	"fieldLabel": `fieldLabel__CyLcM`,
	"helperText": `helperText__yp6EO`,
	"switchWrapper": `switchWrapper__yXgMq`
};
module.exports = ___CSS_LOADER_EXPORT___;
